export default "__VITE_ASSET__C94pGDGB__"